export const inspectTable_1 = [
  {
    title: `1) 바닥부`,
    subTitle: `철도`,
    content: `도상결빙에 의한 궤도틀림<br/>
<span style='font-weight: normal;'>- 궤간</span><br/>
<span style='font-weight: normal;'>- 수평, 고저, 방향</span><br/>
<span style='font-weight: normal;'>- 비틀림</span>`,
    isChecked: ``,
  },
  {
    title: `1) 바닥부`,
    subTitle: `철도`,
    content: `배수 및 배수구 상태`,
    isChecked: ``,
  },
  {
    title: `1) 바닥부`,
    subTitle: `철도`,
    content: `도상부 분리 및 균열 등<br/>
<span style='font-weight: normal;'>- 분리면 범위 및 균열 진행성</span><br/>
<span style='font-weight: normal;'>- 신규 균열 발생 여부</span>`,
    isChecked: ``,
  },
  {
    title: `1) 바닥부`,
    subTitle: `철도`,
    content: `침목의 균열 발생 및 파손`,
    isChecked: ``,
  },
  {
    title: `1) 바닥부`,
    subTitle: `도로`,
    content: `포장부 파손`,
    isChecked: ``,
  },
  {
    title: `1) 바닥부`,
    subTitle: `도로`,
    content: `바닥부 체수 및 결빙`,
    isChecked: ``,
  },
  {
    title: `1) 바닥부`,
    subTitle: `도로`,
    content: `배수구 체수 및 결빙`,
    isChecked: ``,
  },
  {
    title: `2) 본선 라이닝 점검`,
    content: `라이닝 콘크리트 균열 동반 누수<br/>
<span style='font-weight: normal;'>- 균열 진행성 (폭, 길이)</span><br/>
<span style='font-weight: normal;'>- 누수범위 및 결빙 상태</span>`,
    isChecked: ``,
  },
  {
    title: `2) 본선 라이닝 점검`,
    content: `시공이음부 및 타일부 누수 및 들뜸<br/>
<span style='font-weight: normal;'>- 시공이음부 및 타일부 들뜸 범위 등</span><br/>
<span style='font-weight: normal;'>- 지하수 용출 및 토사유출 상태</span>`,
    isChecked: ``,
  },
  {
    title: `2) 본선 라이닝 점검`,
    content: `터널 내 측빙, 고드름 발생 여부`,
    isChecked: ``,
  },
  {
    title: `2) 본선 라이닝 점검`,
    content: `개착구간 라이닝 상태(균열, 누수)`,
    isChecked: ``,
  },
  {
    title: `3) 주변지형 및 기타`,
    content: `터널 상부 지형변화 여부`,
    isChecked: ``,
  },
  {
    title: `3) 주변지형 및 기타`,
    content: `터널 주변 굴착공사 여부`,
    isChecked: ``,
  },
  {
    title: `3) 주변지형 및 기타`,
    content: `갱구부 비탈면 및 옹벽 상태`,
    isChecked: ``,
  },
  {
    title: `3) 주변지형 및 기타`,
    content: `갱문 상부 배수로 상태 및 기타`,
    isChecked: ``,
  },
];

export const inspectTable_2 = [
  {
    title: `1) 상부구조 상면(교면, 배수, 난간 및 연석, 신축이음)`,
    content: `교면포장(아스콘, 콘크리트) 손상<br/>
<span style='font-weight: normal;'>- 균열, 소성변형, 요철, 함몰</span>`,
    isChecked: ``,
  },
  {
    title: `1) 상부구조 상면(교면, 배수, 난간 및 연석, 신축이음)`,
    content: `배수시설(배수구, 배수관)<br/>
<span style='font-weight: normal;'>- 파손(Grating, 관), 체수, 막힘</span>`,
    isChecked: ``,
  },
  {
    title: `1) 상부구조 상면(교면, 배수, 난간 및 연석, 신축이음)`,
    content: `난간 및 연석<br/>
<span style='font-weight: normal;'>- 난간 파손, 부식</span><br/>
<span style='font-weight: normal;'>- 연석 파손, 박리(염해, 동결융해)</span>`,
    isChecked: ``,
  },
  {
    title: `1) 상부구조 상면(교면, 배수, 난간 및 연석, 신축이음)`,
    content: `신축이음<br/>
<span style='font-weight: normal;'>- 본체 변형, 씰링 파손, 누수, 이상음</span><br/>
<span style='font-weight: normal;'>- 후타재 파손, 박리(염해, 동결융해)</span>`,
    isChecked: ``,
  },
  {
    title: `2) 상부구조 하면(바닥판, 거더, 받침)`,
    content: `바닥판(강바닥판, RC)<br/>
<span style='font-weight: normal;'>- 균열, 누수, 백태</span><br/>
<span style='font-weight: normal;'>- 강바닥판 변형, RC 철근노출</span>`,
    isChecked: ``,
  },
  {
    title: `2) 상부구조 하면(바닥판, 거더, 받침)`,
    content: `거더(박스, 플레이트)<br/>
<span style='font-weight: normal;'>- 강박스 및 플레이트 용접부 균열</span><br/>
<span style='font-weight: normal;'>- 2차부재 변형, 연결부 상태</span><br/>
<span style='font-weight: normal;'>- 콘크리트 박스 균열, 누수, 백태</span>`,
    isChecked: ``,
  },
  {
    title: `2) 상부구조 하면(바닥판, 거더, 받침)`,
    content: `받침(강재, 탄성)<br/>
<span style='font-weight: normal;'>- 가동불량, 앵커볼트 파손</span><br/>
<span style='font-weight: normal;'>- 받침모르타르 균열, 파손(동결융해)</span>`,
    isChecked: ``,
  },
  {
    title: `3) 하부구조(교대, 교각, 기초)`,
    content: `교대<br/>
<span style='font-weight: normal;'>- 흉벽 기울기 이상(측방유동), 토사유실</span><br/>
<span style='font-weight: normal;'>- 균열, 신축이음 누수, 백태</span>`,
    isChecked: ``,
  },
  {
    title: `3) 하부구조(교대, 교각, 기초)`,
    content: `교각<br/>
<span style='font-weight: normal;'>- 침하(부등침하), 기울기 이상</span><br/>
<span style='font-weight: normal;'>- 균열, 누수, 백태</span>`,
    isChecked: ``,
  },
  {
    title: `3) 하부구조(교대, 교각, 기초)`,
    content: `기초<br/>
<span style='font-weight: normal;'>- 세굴(직접기초 및 말뚝 노출), 침식`,
    isChecked: ``,
  },
];

export const inspectTable_3 = [
  {
    title: `1) 콘크리트 옹벽`,
    content: `옹벽 파손 및 손상, 균열 발생 여부`,
    isChecked: ``,
  },
  {
    title: `1) 콘크리트 옹벽`,
    content: `누수, 층분리 및 박락, 백태 발생 여부`,
    isChecked: ``,
  },
  {
    title: `1) 콘크리트 옹벽`,
    content: `철근 노출 발생 여부`,
    isChecked: ``,
  },
  {
    title: `1) 콘크리트 옹벽`,
    content: `배수공 막힘 여부`,
    isChecked: ``,
  },
  {
    title: `2) 보강토 옹벽 및 석축`,
    content: `파손 및 손상 , 균열 발생 여부`,
    isChecked: ``,
  },
  {
    title: `2) 보강토 옹벽 및 석축`,
    content: `블록(판넬) 유실 여부`,
    isChecked: ``,
  },
  {
    title: `2) 보강토 옹벽 및 석축`,
    content: `블록(판넬) 이격 발생 여부`,
    isChecked: ``,
  },
  {
    title: `2) 보강토 옹벽 및 석축`,
    content: `견칫돌 발생의 여부`,
    isChecked: ``,
  },
  {
    title: `2) 보강토 옹벽 및 석축`,
    content: `견칫돌 유실 여부`,
    isChecked: ``,
  },
  {
    title: `2) 보강토 옹벽 및 석축`,
    content: `견칫돌 이격 발생 유무`,
    isChecked: ``,
  },
  {
    title: `3) 게비온 옹벽`,
    content: `채움재 유실 여부`,
    isChecked: ``,
  },
  {
    title: `3) 게비온 옹벽`,
    content: `와이어 메쉬(wire mesh)의 파손 여부`,
    isChecked: ``,
  },
  {
    title: `4) 주변시설`,
    content: `주변시설(배수로, 측구)의 존재 여부`,
    isChecked: ``,
  },
  {
    title: `4) 주변시설`,
    content: `주변 배수시설의 관리 상태`,
    isChecked: ``,
  },
  {
    title: `4) 주변시설`,
    content: `도로 융기 발생 여부(도로시설)`,
    isChecked: ``,
  },
  {
    title: `4) 주변시설`,
    content: `침하의 발생 여부(상부지반)`,
    isChecked: ``,
  },
  {
    title: `4) 주변시설`,
    content: `주변 시설 변형 여부`,
    isChecked: ``,
  },
  {
    title: `4) 주변시설`,
    content: `시설물 파손 여부`,
    isChecked: ``,
  },
  {
    title: `4) 주변시설`,
    content: `배수시설의 배수기능 유지 여부`,
    isChecked: ``,
  },
];

export const inspectTable_4 = [
  {
    title: `1) 건축물의 구조안전을 해치는 사항`,
    content: `가. 주요 부재의 구조적 균열과 변형`,
    isChecked: ``,
  },
  {
    title: `1) 건축물의 구조안전을 해치는 사항`,
    content: `• 슬래브의 상하부에 규칙적인 균열과 변형(기둥 주변융기, 중앙부 처짐)등 발생 여부`,
    isChecked: ``,
  },
  {
    title: `1) 건축물의 구조안전을 해치는 사항`,
    content: `• 기둥에 결함 발생 여부(경사균열과 수평균열, 피복 콘크리트의 터짐과 주철근의 노출)`,
    isChecked: ``,
  },
  {
    title: `1) 건축물의 구조안전을 해치는 사항`,
    content: `• 보에 결함 발생 여부(단부 사인장 균열, 중앙부 휨 균열)`,
    isChecked: ``,
  },
  {
    title: `1) 건축물의 구조안전을 해치는 사항`,
    content: `나. 축대, 옹벽의 안전상태`,
    isChecked: ``,
  },
  {
    title: `1) 건축물의 구조안전을 해치는 사항`,
    content: `• 수평이동, 침하, 기울어짐등 발생 여부`,
    isChecked: ``,
  },
  {
    title: `1) 건축물의 구조안전을 해치는 사항`,
    content: `• 균열과 변형(배부름) 발생 여부`,
    isChecked: ``,
  },
  {
    title: `1) 건축물의 구조안전을 해치는 사항`,
    content: `• 배면토의 침하, 침수, 배수구 막힘 여부`,
    isChecked: ``,
  },
  {
    title: `1) 건축물의 구조안전을 해치는 사항`,
    content: `다. 부등침하`,
    isChecked: ``,
  },
  {
    title: `1) 건축물의 구조안전을 해치는 사항`,
    content: `• 건축물의 기울음, 외벽 경사균열 발생 여부`,
    isChecked: ``,
  },
  {
    title: `1) 건축물의 구조안전을 해치는 사항`,
    content: `• 주변지반 부분침하, 융기현상 발생 여부`,
    isChecked: ``,
  },
  {
    title: `1) 건축물의 구조안전을 해치는 사항`,
    content: `• 창과 문틀의 뒤틀림과 여닫기 곤란 상태 여부`,
    isChecked: ``,
  },
  {
    title: `1) 건축물의 구조안전을 해치는 사항`,
    content: `• 바닥 포장 부위 침하 및 균열 발생 여부`,
    isChecked: ``,
  },
  {
    title: `2) 건축물의 내구성 결함 사항`,
    content: `• 각부의 균열, 누수, 백화나 습율(결로)등의 발생 여부`,
    isChecked: ``,
  },
  {
    title: `2) 건축물의 내구성 결함 사항`,
    content: `• 철재 부식 발생 여부`,
    isChecked: ``,
  },
  {
    title: `3) 기타 결함 사항`,
    content: `• 하수관로 및 맨홀의 배수, 청소상태 불량 여부`,
    isChecked: ``,
  },
  {
    title: `3) 기타 결함 사항`,
    content: `• 담장의 전도 징후 여부`,
    isChecked: ``,
  },
  {
    title: `3) 기타 결함 사항`,
    content: `• 빗물 홈통과 루프드레인의 기능이상 유무`,
    isChecked: ``,
  },
  {
    title: `3) 기타 결함 사항`,
    content: `• 수도, 전기, 가스, 통신선 등의 이상 유무`,
    isChecked: ``,
  },
];
